module.exports = __webpack_public_path__ + "img/mapworks-logo.a48c881e.svg";